import { render } from "./ListadoVentasDashboard.vue?vue&type=template&id=5e6b288f&scoped=true"
import script from "./ListadoVentasDashboard.vue?vue&type=script&lang=js"
export * from "./ListadoVentasDashboard.vue?vue&type=script&lang=js"

import "./ListadoVentasDashboard.vue?vue&type=style&index=0&id=5e6b288f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6b288f"]])

export default __exports__